export default __webpack_public_path__ + "static/media/food-and-drink.f263d3cd.png";